import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Modal, Theme, useMediaQuery } from '@material-ui/core';
import CustomButton from 'src/components/CustomComponents/CustomButton';
import toast from 'react-hot-toast';
import CustomModal from 'src/components/CustomComponents/CustomModal';
import { useMutation } from '@apollo/client';
import { EDITUSER } from 'src/graphql/mutations';
import useAuth from 'src/hooks/useAuth';

// stating ID
// const clientId = '67f92e4d3f77ac06f57b30c9';

// PROD client ID
const clientId = '68025b3e6043de192dacf2ea';

const SCOPES = 'subscription,profile,rating';

const WprConnection = ({ wprAccessCode, setWprAccessCode, isResponsive }) => {
  const { user, dispatch } = useAuth();
  const [isIframeOpen, setIsIframeOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  const [updateUser, { loading: userUpdateLoading }] = useMutation(EDITUSER) as any;

  const handleConnectWprClick = () => {
    setIsIframeOpen(true);
    // setLoading(true);
    // setIframeLoading(true);
  };

  const handleMessage = async (event: MessageEvent) => {
    const iframe = document.getElementById('wpr-frame') as HTMLIFrameElement;
    if (iframe) {
      try {
        // Get the current iframe URL
        const currentUrl = iframe.contentWindow?.location.href;

        // Check if the URL contains the authorization code
        if (currentUrl && currentUrl.includes('code=')) {
          const urlParams = new URLSearchParams(new URL(currentUrl).search);
          const authCode = urlParams.get('code');

          if (authCode) {
            console.log('Authorization code:', authCode);
            setWprAccessCode(authCode);
            setIsIframeOpen(false);
            // Handle the authorization code here
            // You might want to call your updateUser mutation or handle the code as needed
          }
        }
      } catch (error) {
        // If we can't access the iframe URL due to CORS, we'll get a security error
        // This is expected when the iframe is on a different domain
        console.log('Cannot access iframe URL directly due to same-origin policy...');
      }
    }
  };

  // Add an interval to check the iframe URL
  useEffect(() => {
    if (isIframeOpen) {
      const checkInterval = setInterval(() => {
        const iframe = document.getElementById('wpr-frame') as HTMLIFrameElement;
        if (iframe) {
          try {
            const currentUrl = iframe.contentWindow?.location.href;
            if (currentUrl && currentUrl.includes('code=')) {
              const urlParams = new URLSearchParams(new URL(currentUrl).search);
              const authCode = urlParams.get('code');
              if (authCode) {
                console.log('Authorization code:', authCode);
                setIsIframeOpen(false);
                clearInterval(checkInterval);
                // Handle the authorization code here
              }
            }
          } catch (error) {
            // Expected CORS error when trying to access cross-origin iframe
          }
        }
      }, 500); // Check every 500ms

      return () => clearInterval(checkInterval);
    }
  }, [isIframeOpen]);

  const handleCloseModal = () => {
    setIsIframeOpen(false);
    setLoading(false);
  };
  const handleIframeLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    console.log('e >>', e);
    setIframeLoading(false);
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Define a callback function to generate the callback URI
  const getCallbackUri = () => {
    return window.location.href; // Replace with your logic to generate the URI
  };

  // Use the callback function to set the URL
  const url = `${process.env.REACT_APP_WPR_BASE_URL}/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(getCallbackUri())}&scope=${encodeURIComponent(
    SCOPES,
  )}&state=sasasas&client_user_id=123&source=thepad`;

  return (
    <Box sx={{ position: 'relative' }}>
      <CustomButton
        shape="default"
        size="medium"
        variant="primary"
        onClick={handleConnectWprClick}
        disabled={!!wprAccessCode}
        sx={{
          background: '#3a79e0',
          width: '100%',
          fontWeight: 500,
          '&.Mui-disabled': {
            background: '#3a79e0',
            opacity: 0.7,
          },
        }}
      >
        {loading ? (
          <CircularProgress size={25} />
        ) : wprAccessCode ? (
          isResponsive ? (
            'Connected'
          ) : location.pathname?.includes('/tournaments') ? (
            'WPR connecting please wait'
          ) : (
            'WPR connected'
          )
        ) : isResponsive ? (
          'Connect'
        ) : (
          'Connect WPR'
        )}
      </CustomButton>

      <CustomModal openOvveride={isIframeOpen} onClose={() => handleCloseModal()}>
        <Box
          sx={{
            maxWidth: { xs: 'none', sm: '400px' },
            minWidth: { xs: '100%', sm: '400px' },
            height: '90vh',
            maxHeight: '800px',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {/* {iframeLoading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )} */}

          <iframe
            id="wpr-frame"
            src={url}
            width="100%"
            height="100%"
            style={{
              position: 'absolute',
              display: 'block',
              border: 'none',
              height: '100%',
              maxHeight: '800px',
              WebkitOverflowScrolling: 'touch',
            }}
            onError={(e) => {
              console.error('Iframe failed to load', e);
              toast.error('Something went wrong loading WPR');
              setLoading(false);
              setIsIframeOpen(false);
            }}
            onLoad={(e) => handleIframeLoad(e)}
          />
        </Box>
      </CustomModal>
    </Box>
  );
};

export default WprConnection;
